# Used by onboarding
# Once a DIS request has been created, the application polls the server
# repeatedly to verify its status. Once the request has been acknowledged,
# the behaviour directs the user to appropriate DIS UI.

redirect = (url) ->
  window.location = url

state_machine = (instance) ->
  status_endpoint = $(instance).data('status-endpoint')
  timeout = 2500 # ms
  $busy = $(instance).children('.busy')

  do pollStatus = ->
    $.getJSON(status_endpoint)
    .done( (response, status, xhr) ->
      switch response.state
        when 'pending', 'started' then setTimeout(pollStatus, timeout)
        else setTimeout((-> window.location.reload()), 1500)
    )
    .fail( (xhr, status, err) ->
      if xhr.status == 401
        # waited too long, show re-entry screen by reloading website
        window.location.reload()
      else
        console.log("Error polling Camunda status: ", status, err)
        setTimeout(pollStatus, timeout)
    )

$ ->
  $('[data-behaviour=camunda-state-machine]').each -> state_machine(this)
